import { render, staticRenderFns } from "./Prize_shop.vue?vue&type=template&id=2bce6ec1"
import script from "./Prize_shop.vue?vue&type=script&lang=js"
export * from "./Prize_shop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports